import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import { computed, reactive, toRefs } from "vue";
//@ts-ignore
import { useCommonVars } from "@wkComposables/useCommonVars";
export function useAgencyFilters() {
  var state = reactive({
    agencyFilter: {
      name: "",
      franchiseId: null,
      uri: "",
      idName: ""
    },
    currentSearchFranchiseIdName: ""
  });
  var currentSearchName = computed(function () {
    return new URLSearchParams(window.location.search).get("Nome");
  });
  var franchiseList = computed(function () {
    return getOptions("franchiseList");
  });
  var currentSearchFranchiseOptions = computed(function () {
    var _a;
    return (_a = franchiseList.value.find(function (franchise) {
      return franchise.label.toLowerCase() === state.currentSearchFranchiseIdName.toLowerCase();
    })) !== null && _a !== void 0 ? _a : null;
  });
  var _useCommonVars = useCommonVars(),
    cdn = _useCommonVars.cdn,
    labels = _useCommonVars.wkLabels;
  var getOptions = function getOptions(key) {
    return window["_options"][key];
  };
  return Object.assign(Object.assign({}, toRefs(state)), {
    currentSearchName: currentSearchName,
    franchiseList: franchiseList,
    currentSearchFranchiseOptions: currentSearchFranchiseOptions,
    cdn: cdn,
    labels: labels,
    getOptions: getOptions
  });
}